import React from "react";
import CrmSectionPage from "./CrmSectionPage";

export default function Reports() {
  return <CrmSectionPage sectionKey="reports" />;
}
